import {Component} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {DialogComponent} from "@common-module/dialog/dialog/dialog.component";
import {ToolbarComponent} from "../../main/toolbar/toolbar.component";
import {ButtonCancelComponent} from "@common-module/buttons/base/concrete/button-cancel/button-cancel.component";
import {ButtonPrimaryComponent} from "@common-module/buttons/base/style/button-primary/button-primary.component";

@Component({
  selector: 'app-toolbar-dialog',
  imports: [
    TranslateModule,
    DialogComponent,
    ToolbarComponent,
    ButtonCancelComponent,
    ButtonPrimaryComponent
  ],
  templateUrl: './toolbar-dialog.component.html',
  styleUrl: './toolbar-dialog.component.scss'
})
export class ToolbarDialogComponent {

}
